export default function SectionContent({children}) {

    return (
        <div className="xs:mt-20 2xs:mt-10 2xs:mb-10">
            {children}
        </div>
    )
}